import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import { cn } from '@avodah-inc/ui/utils';

const minusIconVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
      primary: 'text-primary',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type MinusIconProps = {
  width?: string | number;
  height?: string | number;
  viewBox?: string;
  fill?: string;
} & React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof minusIconVariants>;

const MinusIcon = React.forwardRef<SVGSVGElement, MinusIconProps>(
  (
    {
      className,
      variant,
      viewBox,
      width,
      height,
      fill = 'currentColor',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        className={cn(
          minusIconVariants({
            variant,
            className,
          }),
        )}
        fill={fill}
        height={height}
        ref={ref}
        viewBox={viewBox ?? '0 0 16 16'}
        width={width}
        {...props}
      >
        <path d="M2.664 8.66665H13.3333C13.5101 8.66665 13.6797 8.59641 13.8047 8.47138C13.9298 8.34636 14 8.17679 14 7.99998C14 7.82317 13.9298 7.6536 13.8047 7.52858C13.6797 7.40355 13.5101 7.33331 13.3333 7.33331H2.664C2.48719 7.33331 2.31762 7.40355 2.19259 7.52858C2.06757 7.6536 1.99733 7.82317 1.99733 7.99998C1.99733 8.17679 2.06757 8.34636 2.19259 8.47138C2.31762 8.59641 2.48719 8.66665 2.664 8.66665Z" />
      </svg>
    );
  },
);

MinusIcon.displayName = 'MinusIcon';

export { MinusIcon, minusIconVariants };
